import { createCoreVueApp } from '@/entrypoints/helpers/core-vue-app';
import Autocomplete from '@/shared/components/Shopify/Autocomplete.vue';
import { searchEvents } from '@/shared/constants/constants';
import { debounce } from '@/shared/utils/functions.js';

const debugEnabled = window.location.search.includes('debug_autocomplete');
const desktopSearchName = 'header-searchbox';
let activeSearch;
let SearchInstance;

const createVueInstance = async (name) => {
  const el = document.getElementById(name);
  if (!el) {
    if (debugEnabled) {
      console.info(
        `No element found for id "${name}", aborting autocomplete init.`
      );
    }
    return;
  }

  const { searchTerms, inputId } = el.dataset;

  // If we are already mounted on this element, destroy it first (resilient re-init)
  if (SearchInstance && SearchInstance._container === el) {
    SearchInstance.unmount();
  }

  SearchInstance = await createCoreVueApp(
    Autocomplete,
    el,
    { searchTerms, inputId },
    null,
    { noClients: true }
  );
  SearchInstance.mount(el);
};

export const initAutoComplete = ({ force } = {}) => {
  // Logic simplified since we use the same ID for both mobile and desktop
  const targetId = desktopSearchName;

  if (force || activeSearch !== targetId) {
    activeSearch = targetId;
    if (SearchInstance) {
      SearchInstance.unmount();
    }
    return createVueInstance(targetId);
  }
};

const initAutoCompleteDebounced = debounce(() => initAutoComplete(), 400);

window.addEventListener('resize', initAutoCompleteDebounced);

window.addEventListener(searchEvents.NATIVE_HEADER_SWAPPED, async (event) => {
  try {
    await initAutoComplete({ force: true });

    const { focusInputId } = event.detail ?? {};
    if (focusInputId) {
      document.getElementById(focusInputId)?.focus();
    }
  } catch (e) {
    console.error('Error mounting native search suggestions:', e);
  }
});
